// 📁 NotificationCard.js
import React, { useState } from 'react';
import { CheckCircle, XCircle, Eye } from 'react-bootstrap-icons';

const NotificationCard = ({ notif, onDecision, user }) => {
  const isAccessRequest = notif.topic?.startsWith("request_access");
  const isRead = notif.is_read === 1;
  const date = new Date(notif.created_at).toLocaleString();
  const [showReasonInput, setShowReasonInput] = useState(false);
  const [markedAsRead, setMarkedAsRead] = useState(isRead);

  const handleMarkAsRead = () => {
    onDecision(notif, 'read');
    setMarkedAsRead(true);
  };

  return (
    <div className={`card mb-3 shadow-sm ${isAccessRequest ? 'border-warning' : 'border-light'} ${markedAsRead ? 'bg-light' : ''}`}>
      <div className="card-body d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <img
            src={
              user?.avatar_url
                ? `${user.avatar_url}`
                : `https://api.dicebear.com/7.x/initials/svg?seed=${notif.user_id}`
            }
            alt="avatar"
            className="rounded-circle"
            width="48"
            height="48"
          />

          <div>
            <div className="fw-bold text-primary">
              {isAccessRequest ? '🔓 Demande d\'accès' : notif.topic}
              {notif.project_id ? ` — Projet #${notif.project_id}` : ''}
            </div>
            <div className="text-muted small">
              {notif.user_id} — 🕓 {date}
            </div>
          </div>
        </div>

       <div className="text-end mt-3 mt-md-0">
  {notif.decision ? (
    <>
      <span className={`badge ${notif.decision === 'approved' ? 'bg-success' : 'bg-danger'}`}>
        {notif.decision === 'approved' ? '✅ Approuvé' : '❌ Refusé'}
      </span>
      {notif.reason && (
        <div className="text-muted small mt-1">Motif : {notif.reason}</div>
      )}
    </>
  ) : isAccessRequest ? (
    <>
      <button
        className="btn btn-sm btn-outline-success me-2"
        onClick={() => onDecision(notif, 'approved')}
      >
        <CheckCircle className="me-1" /> Approuver
      </button>
      <button
        className="btn btn-sm btn-outline-danger"
        onClick={() => setShowReasonInput(true)}
      >
        <XCircle className="me-1" /> Refuser
      </button>
      {showReasonInput && (
        <div className="mt-2">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Motif du refus"
            onBlur={(e) => {
              const reason = e.target.value.trim();
              if (reason) onDecision(notif, 'denied', reason);
            }}
          />
        </div>
      )}
    </>
  ) : !markedAsRead && (
    <button
      className="btn btn-sm btn-outline-secondary"
      onClick={handleMarkAsRead}
    >
      <Eye className="me-1" /> Marquer comme lu
    </button>
  )}
</div>

      </div>
    </div>
  );
};

export default NotificationCard;
